import { render } from "./mAndService.vue?vue&type=template&id=96a1bd62&scoped=true"
import script from "./mAndService.vue?vue&type=script&lang=js"
export * from "./mAndService.vue?vue&type=script&lang=js"

import "./mAndService.vue?vue&type=style&index=0&id=96a1bd62&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96a1bd62"]])

export default __exports__